import api from "./apiBase";

function getCategories() {
  return api.get("categories");
}

function getCatalog(param) {
  return api.get(`/designs?${param}`);
}

function getDesignById(id) {
  return api.get(`/designs/${id}`);
}

function getStlFile(id) {
  return api.get(`/design-files/download/${id}`);
}

async function uploadDesignFormData(formData) {
  try {
    const response = await api.post("/admin/designs", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao enviar FormData:", error);
    throw error;
  }
}

function getFonts() {
  return api.get("/fonts");
}

export {
  getCategories,
  getCatalog,
  getDesignById,
  getStlFile,
  uploadDesignFormData,
  getFonts,
};
